import { render, staticRenderFns } from "./VehicleInspectionSchemesPage.vue?vue&type=template&id=6f80f43e&"
import script from "./VehicleInspectionSchemesPage.vue?vue&type=script&lang=js&"
export * from "./VehicleInspectionSchemesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports